import axios from 'axios'
import React from 'react'
import { useEffect } from 'react'
import { useState } from 'react'
import { useDispatch } from 'react-redux'
import { useSelector } from 'react-redux'
import {
    Link,
    Navigate,
    useLocation,
    useNavigate,
    useParams
} from 'react-router-dom'
import { ReactComponent as IconBackArrow } from '../../../../assets/images/icons/icon-back-red.svg'
import Button from '../../../../components/Button/Button'
import TableListing from '../../../../components/TableListing/TableListing'
import ModalPopup from '../../../../components/Modal/ModalPopup'
import DeleteRedIcon from '../../../../assets/images/icons/delete-red-icon.svg'
import {
    DELETE_VIEW_PRODUCT_VARIANT_DATA,
    DELETE_WHOLE_CATALOG_DATA,
    SELLER_ADDPRODUCT,
    SELLER_LISTPRODUCT,
    VIEW_CATALOG_DATA_LIST
} from '../../../../Redux-Toolkit/Actions/sagaActions'
import BinIcon from '../../../../assets/images/icons/bin-icon.svg'
import EditIcon from '../../../../assets/images/icons/icon-edit-black.svg'
import {
    createColumnHelper,
    getCoreRowModel,
    getSortedRowModel,
    useReactTable
} from '@tanstack/react-table'
import AddProductBasicDetails from '../AddCatalog/components/AddProductBasicDetails'
import { ReactComponent as Plus } from '../../../../assets/images/icons/icon-plus-white.svg'
import {
    getColorId,
    removeIndexDBData,
    sellerDeleteProductSuccess,
    sellerEditProductSuccess,
    sellerVariantDataFromIndexedDB,
    showingPopup,
    viewcatalogEditVariant
} from '../../../../Redux-Toolkit/Slices/catalogSlice'
import AddVariant from '../AddCatalog/components/AddProductVariant/InnerComponents/AddVariant/AddVariant'
import { catalogsupload, resetpassword } from '../../../../config/routingConsts'
import { useForm } from 'react-hook-form'
import {
    loadInitialVariantDataFromIndexedDB,
    storeDataInIndexedDB,
    deleteDataFromIndexDB
} from '../../../../Functions/indexdb'
import { deleteDB, openDB } from 'idb'
import Loader from '../../../../components/Loader'

const ViewCatalog = () => {
    const { id } = useParams()
    const { reset } = useForm({ mode: 'all' })
    const {
        viewCatalogDataList,
        viewCatalogEditVariantDataList,
        addVariantDataList,
        isloadingIDB,
        isloading,
        addMaterialData
    } = useSelector((action) => action?.catalogSlice)
    const getSessionEditData = JSON.parse(sessionStorage.getItem('ProductBD'))
    const [subBtnDisable, setSubBtnDisable] = useState(false)
    const [first, setfirst] = useState(null)
    const [imageModalShow,setImageModalShow] = useState(false)
    const [addVariant, setAddVariant] = useState(false)
    const dispatch = useDispatch()
    const [no, setNo] = useState(0)
    const navigate = useNavigate()
    const { pathname, state } = useLocation()
    const [deleteModal, setDeleteModalShow] = useState(false)
    const [deleteProductIDModalShow, setDeleteProductIdModalShow] = useState(false)

    ////////// delete index db ////////
    useEffect(() => {
        dispatch({ type: VIEW_CATALOG_DATA_LIST, payload: { catalogId: id } })
        return async () => {
            const dbName = 'myIndexedDB'
            sessionStorage.removeItem('ProductBD')
            try {
                await deleteDB(dbName)
            } catch (error) {
                console.warn('Error deleting IndexedDB database:', error)
            }
        }
    }, [id])
    /////////// end index db //////

    /////// delete modal show on variant id//////
    const [delID, setDelID] = useState(null)
    const deleteModalFunction = (e) => {
        setDeleteModalShow(true)
        setDelID(e)
    }
    const onDeleteYesBtnClick = () => {
        if (delID?.variantId) {
            dispatch({
                type: DELETE_VIEW_PRODUCT_VARIANT_DATA,
                payload: {
                    catalogId: viewCatalogDataList?.data?.id,
                    variantId: delID?.variantId
                },
                callback: () => {
                    dispatch(deleteDataFromIndexDB(delID?.indexDbId))
                }
            })
        } else {
            dispatch(deleteDataFromIndexDB(delID?.indexDbId))
        }
        setDeleteModalShow(false)
        // dispatch(sellerDeleteProductSuccess(delID?.indexDbId)) delID?.indexDbId
    }
    /////// delete modal show end for variant id///

    ///// image preview function ///////
    const [imgData,setImgData] = useState([])
    const imagePreviewFunction = (img)=>{
        // setImageModalShow(true)
        // setImgData(img)
    }
    ////  End image preview function ///



    useEffect(() => {
        const abc = addVariantDataList.map((res) => {
            return res?.color?._id
        })
        dispatch(getColorId({id:abc}))
    }, [addVariantDataList])

    
    ///////// start product delete whole catalog ////
    const [storeId, setStoreId] = useState(null)
    const productModalShowFunction = (id) => {
        setDeleteProductIdModalShow(true)
        setStoreId(id)
    }
    const onYesBtnClickCatalog = (productId) => {
        if (productId) {
            // setDeleteProductIdModalShow(false)
            dispatch({
                type: DELETE_WHOLE_CATALOG_DATA,
                payload: { catalogId: productId },
                callback: () => {
                    navigate(catalogsupload)
                    // dispatch({type:SELLER_LISTPRODUCT})
                }
            })
        }
        setDeleteProductIdModalShow(false)
    }
    //////// end modal ddelete whole catalog /////

    ////// index DB
    useEffect(() => {
        if (viewCatalogDataList?.data?.addVariant?.length > 0) {
            dispatch(loadInitialVariantDataFromIndexedDB())
        }
    }, [viewCatalogDataList?.data?.addVariant?.length])

    useEffect(() => {
        //////// Add variant start/////
        // if (viewCatalogEditVariantDataList?.length !== 0) {
        const XYZ = viewCatalogDataList?.data?.addVariant?.map((res, index) => {
            const ABC = res?.variantList?.map((v) => ({
                availableQty: v?.availableQty,
                price: v?.mrp,
                SellingPrice: v?.sellingPrice,
                size: { name: v?.size, _id: v?.sizeId }
            }))
            const PQR = res?.productImages?.map((Y) => ({
                blobUrl: Y?.image,
                preview: Y?.image,
                id: Y?._id
            }))
            return {
                color: { name: res?.color, _id: res?.colorId },
                file: PQR,
                addSize: ABC,
                variantId: res?.variantId,
                discountInOne: res?.discountInOne,
                id: index + 1
            }
        })
        const finalDataresult = { addVariant: XYZ }
        dispatch(storeDataInIndexedDB({ addData: XYZ }))
        // }
        ////// Add variant end
    }, [viewCatalogDataList])

    // ///// end indexDB

    /////// update new table  HHHH/////

    const transformDataForTable = (data) => {
        return (
            data?.length !== 0 &&
            data?.map((item, index) => ({
                productImages: (
                    <div className="product-thumbnail">
                        {item?.file?.length > 0 && (
                            <>
                                <img
                                    key={item?.file[0]?._id}
                                    className=""
                                    src={item?.file[0]?.blobUrl}
                                    alt="product-image"
                                    onClick={()=>imagePreviewFunction(item?.file?.map((imagPre,i)=>imagPre?.blobUrl))}
                                />
                                <div className="variant-count">
                                    +{item?.file?.length}
                                </div>
                            </>
                        )}
                    </div>
                ),
                color: item?.color?.name,
                // color:item?.color?.colorId,
                size: item?.addSize?.map((size) => size?.size?.name).join(','),
                availableQty: item?.addSize
                    ?.map((qty) => qty?.availableQty)
                    .join(','),
                price: item?.addSize?.map((price) => price?.price).join(','),
                action: (
                    <div className="action">
                        <span
                            className="edit-btn"
                            onClick={() => {
                                setfirst(index)
                                dispatch(
                                    sellerEditProductSuccess({
                                        addVariant: [item],
                                        key: item?.id
                                    })
                                )
                                setAddVariant(true)
                                // JSON.stringify(sessionStorage.setItem('AddVariant', true))
                            }}
                        >
                            <img src={EditIcon} />
                            Edit
                        </span>
                        <span
                            className="delete-btn"
                            // onClick={()=>{deleteModalFunction(item?.id,item?.addVariant?.map((varID)=>varID?.variantId))}
                            onClick={() => {
                                deleteModalFunction({
                                    indexDbId: item?.id,
                                    variantId: item?.variantId
                                })
                            }}
                            //   setDeleteModalShow(true)
                            // dispatch(sellerDeleteProductSuccess(item?.id))
                            // }
                        >
                            <img src={BinIcon} />
                            Delete
                        </span>
                    </div>
                )
                // size :
            }))
        )
    }
    const columnHelper = createColumnHelper()
    const columns = [
        columnHelper.display({
            id: 'productImages',
            header: () => 'Variant Photos',
            cell: (row) => row?.row?.original?.productImages
        }),
        columnHelper.accessor((row) => row?.color, {
            id: 'color',
            header: () => 'Color'
        }),
        columnHelper.accessor((row) => row?.size, {
            id: 'size',
            header: () => 'Size'
        }),
        columnHelper.accessor((row) => row?.availableQty, {
            id: 'availableQty',
            header: () => 'Available Qty'
        }),
        columnHelper.accessor((row) => row?.price, {
            id: 'price',
            header: () => 'Price'
        }),
        columnHelper.display({
            id: 'action',
            header: () => 'Action',
            cell: (row) => row?.row?.original?.action
        })
    ]
    ////// table end HHHH ///

    const transformedData = transformDataForTable(addVariantDataList)
    const table = useReactTable({
        data: transformedData || [],
        columns: columns || [],
        getCoreRowModel: getCoreRowModel()
    })
    const viewProductBasicDetailData = (id) => {
        setNo(1)
    }

    const [viewData, setViewData] = useState(null)
    useEffect(() => {
        // if(viewEdit){
        if (sessionStorage.getItem('ProductBD')) {
            setViewData(JSON.parse(sessionStorage.getItem('ProductBD')))
        } else {
            const NEWARAY = {
                description: viewCatalogDataList?.data?.description,
                estimatedTime: {
                    name: viewCatalogDataList?.data?.shippingTime,
                    _id: viewCatalogDataList?.data?.shippingTimeId
                },
                gst: viewCatalogDataList?.data?.gst,
                country: {
                    name: viewCatalogDataList?.data?.countryName,
                    _id: viewCatalogDataList?.data?.countryId
                },
                type: {
                    name: viewCatalogDataList?.data?.type,
                    _id: viewCatalogDataList?.data?.typeId
                },
                productMaterial: {
                    name: viewCatalogDataList?.data?.materialName,
                    _id: viewCatalogDataList?.data?.materialId
                },
                productWeight: viewCatalogDataList?.data?.productWeight,
                productTitle: viewCatalogDataList?.data?.productName,
                discountInAll: viewCatalogDataList?.data?.discountInAll
            }
            setViewData(NEWARAY)
        }

        //   sessionStorage.setItem('ProductBD', JSON.stringify(NEWARAY))
        // }
    }, [viewCatalogDataList])

    /////// submit cataloge function ///////
    const SubmitCatalog = () => {
        setSubBtnDisable(true)
        const FinalData = addVariantDataList.map((res) => {
            const { id, ...rest } = res
            const modifiedSizes = res.addSize.map((size) => ({
                size: size.size._id,
                availableQty: String(size.availableQty),
                price: String(size?.price)
            }))
            const modifiedFiles = res.file.map((file) => ({
                blobUrl: file.blobUrl,
                imageName: file.imageName
            }))

            return {
                // ...rest,
                discountInOne: res?.discountInOne,
                color: res?.color?._id,
                addSize: modifiedSizes,
                file: modifiedFiles.filter((e) => !!e.imageName)
                //  file: modifiedFiles
            }
        })
        dispatch({
            type: SELLER_ADDPRODUCT,
            payload: {
                catalogId: viewCatalogDataList?.data?.id,
                mainCategoryId: viewCatalogDataList?.data?.mainCategoryId,
                categoryId: viewCatalogDataList?.data?.categoryId,
                /// Add new Category --Hiren
                subCategoryId : viewCatalogDataList?.data?.subCategoryId, 
                productName: getSessionEditData
                    ? getSessionEditData?.productTitle
                    : viewCatalogDataList?.data?.productName,
                discountInAll: getSessionEditData
                    ? String(getSessionEditData?.discountInAll)
                    : String(viewCatalogDataList?.data?.discountInAll),
                productWeight: getSessionEditData
                    ? getSessionEditData?.productWeight
                    : viewCatalogDataList?.data?.productWeight,
                materialId: getSessionEditData
                    ? getSessionEditData?.productMaterial?._id
                    : viewCatalogDataList?.data?.materialId,
                // typeId: getSessionEditData
                //     ? getSessionEditData?.type?._id
                //     : viewCatalogDataList?.data?.typeId,
                countryId: getSessionEditData
                    ? getSessionEditData?.country?._id
                    : viewCatalogDataList?.data?.countryId,
                gst: getSessionEditData
                    ? getSessionEditData?.gst
                    : viewCatalogDataList?.data?.gst,
                shippingTimeId: getSessionEditData
                    ? getSessionEditData?.estimatedTime?._id
                    : viewCatalogDataList?.data?.shippingTimeId,
                description: getSessionEditData
                    ? getSessionEditData?.description
                    : viewCatalogDataList?.data?.description,
                addVariant: FinalData
            },
            callback: () => {
                navigate('/catalogsupload')
                dispatch(showingPopup(1))
                dispatch(removeIndexDBData())
                setSubBtnDisable(false)
            }
        })
    }

    
    ////// end submit cataloge //////
    return (
        <>
            {/* {isloading  &&  <Loader/>} */}
            {isloadingIDB && <Loader/>}
            {no === 0 && !addVariant ? (
                <>
                    <div className="site-tab-list add-product-variant add-catalog-steps">
                        <div className="white-bg">
                            <div className="title-wrapper">
                                Product Variant Details
                                <div className="title-right flex-row">
                                    {/* Delete button */}
                                    <button
                                        type="button"
                                        className="solid-red-btn flex-shrink-0"
                                        onClick={() => {
                                            productModalShowFunction(id)
                                        }}
                                    >
                                        Delete Catalog
                                    </button>

                                    <button
                                        type="button"
                                        className="solid-red-btn flex-shrink-0"
                                        onClick={() => {
                                            setAddVariant(true)
                                            // sessionStorage.setItem("AddVariant", JSON.stringify(true));
                                        }}
                                    >
                                        <Plus />
                                        Add Variant
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div className="white-bg product-listing">
                            <div className="product-detail-box">
                                <div className="detail-left">
                                    <div className="product-title">
                                        {getSessionEditData?.productTitle
                                            ? getSessionEditData?.productTitle
                                            : viewCatalogDataList?.data
                                                  ?.productName}
                                    </div>
                                    <ul className="product-list">
                                        <li>
                                            Product Weight (gms):{' '}
                                            <b>
                                                {getSessionEditData?.productWeight
                                                    ? getSessionEditData?.productWeight
                                                    : viewCatalogDataList?.data
                                                          ?.productWeight}
                                            </b>
                                        </li>
                                        <li>
                                            {' '}
                                            Product Material:{' '}
                                            <b>
                                                {getSessionEditData
                                                    ?.productMaterial?.name
                                                    ? getSessionEditData
                                                          ?.productMaterial
                                                          ?.name
                                                    : viewCatalogDataList?.data
                                                          ?.materialName}
                                            </b>
                                        </li>
                                        <li>
                                            Type:{' '}
                                            <b>
                                                {getSessionEditData?.type?.name
                                                    ? getSessionEditData?.type
                                                          ?.name
                                                    : viewCatalogDataList?.data
                                                          ?.type}
                                            </b>
                                        </li>
                                        <li>
                                            Country of Origin:{' '}
                                            <b>
                                                {getSessionEditData?.country
                                                    ?.name
                                                    ? getSessionEditData
                                                          ?.country?.name
                                                    : viewCatalogDataList?.data
                                                          ?.countryName}
                                            </b>
                                        </li>
                                        <li>
                                            GST%:{' '}
                                            <b>
                                                {getSessionEditData?.gst
                                                    ? getSessionEditData?.gst
                                                    : viewCatalogDataList?.data
                                                          ?.gst}
                                            </b>
                                        </li>
                                    </ul>
                                </div>
                                <div
                                    className="detail-right"
                                    onClick={() => {
                                        viewProductBasicDetailData(
                                            viewCatalogDataList?.data?.id
                                        )
                                        // sessionStorage.setItem('editBD', 0)
                                    }}
                                >
                                    Edit Product basic details
                                </div>
                            </div>
                        </div>
                        {viewCatalogDataList?.data?.addVariant?.length !==
                            0 && (
                            <div className="product-listing">
                                {/* <TableListing table={table} addVariantDataList={viewCatalogDataList} /> */}
                                <TableListing
                                    table={table}
                                    addVariantDataList={addVariantDataList}
                                />

                                <div className="button-wrapper">
                                    <Button
                                        text="Discard Catalog"
                                        className="solid-black-btn"
                                        type="button"
                                        onClick={() => {
                                            navigate(catalogsupload)
                                        }}
                                    />
                                    <Button
                                        type="button"
                                        text="Submit Catalog"
                                        className="solid-red-btn"
                                        onClick={() => SubmitCatalog()}
                                        disabled={subBtnDisable}
                                    />
                                </div>
                            </div>
                        )}
                    </div>
                </>
            ) : !addVariant ? (
                <AddProductBasicDetails
                    viewEdit={viewCatalogDataList?.data}
                    setNo={setNo}
                    viewData={viewData}
                />
            ) : (
                <AddVariant
                    kkk
                    viewData={viewCatalogDataList}
                    first={first}
                    setAddVariant={setAddVariant}
                    viewAddVariantData={viewCatalogDataList?.data}
                />
            )}

            {/* Delete Variant Modal */}
            <ModalPopup
                show={deleteModal}
                handleClose={() => setDeleteModalShow(true)}
                handleShow={() => setDeleteModalShow(true)}
                cname="accept-item confirm-modal delete-modal"
            >
                <img src={DeleteRedIcon} alt="" />
                <h2>Do you want to delete your variant?</h2>
                <div className="modal-btn-group">
                    <Button
                        type="button"
                        commonClass="border-red-btn modal-btn"
                        text={'No'}
                        onClick={() => setDeleteModalShow(false)}
                    />
                    <Button
                        type="button"
                        commonClass="solid-red-btn modal-btn"
                        text={'Yes'}
                        onClick={() => {
                            onDeleteYesBtnClick(delID)
                            // setDeleteModalShow(false)
                            // dispatch(sellerDeleteProductSuccess(delID))
                        }}
                    />
                </div>
            </ModalPopup>
            {/* end delete Variant modal */}

            {/* Delete Whole Product Modal  */}
            <ModalPopup
                show={deleteProductIDModalShow}
                handleClose={() => setDeleteProductIdModalShow(true)}
                handleShow={() => setDeleteProductIdModalShow(true)}
                cname="accept-item confirm-modal delete-modal"
            >
                <img src={DeleteRedIcon} alt="" />
                <h2>Do you want to delete your product catalog?</h2>
                <div className="modal-btn-group">
                    <Button
                        type="button"
                        commonClass="border-red-btn modal-btn"
                        text={'No'}
                        onClick={() => setDeleteProductIdModalShow(false)}
                    />
                    <Button
                        type="button"
                        commonClass="solid-red-btn modal-btn"
                        text={'Yes'}
                        onClick={() => {
                            onYesBtnClickCatalog(storeId)
                            // dispatch(sellerDeleteProductSuccess(delID))
                        }}
                    />
                </div>
            </ModalPopup>
            {/* Delete end Whole Product Modal */}

            {/* image modal pop up */}
            <ModalPopup
                show={imageModalShow}
                handleClose={() => setImageModalShow(false)}
                handleShow={() => setImageModalShow(true)}
                cname="accept-item confirm-modal delete-modal"
            >
                <div>
                    {imageModalShow ? (
                        // <img src={imgData} alt="" width="100%" height="100%" centered />
                        imgData.map((imageUrl, index) => (
                            <img key={index} src={imageUrl} alt={`image-${index}`} width="100%" height="100%" centered />
                        ))
                    ) : (
                        "No Image"
                    )}
                </div>
            </ModalPopup>
            {/* image modal pop-up end */}
        </>
    )
}

export default ViewCatalog
